import type { DocumentType, DocumentTypeConfig, FileFormat } from "../types";
import { notificationConfig } from "./notificationConfig";
import { impactConfig } from "./impactConfig";
import { notificationDecisionConfig } from "./notificationDecisionConfig";
import { riskAnalysisConfig } from "./riskAnalysisConfig";

export const documentTypeRegistry: Record<DocumentType, DocumentTypeConfig> = {
  notification: notificationConfig,
  impact: impactConfig,
  notification_decision: notificationDecisionConfig,
  risk_analysis: riskAnalysisConfig,
};

export function getDocumentTypeConfig(
  documentType: DocumentType
): DocumentTypeConfig {
  return documentTypeRegistry[documentType];
}

export function isFormatSupported(
  documentType: DocumentType,
  format: FileFormat
): boolean {
  const config = documentTypeRegistry[documentType];
  return config.supportedFormats.includes(format);
}
